import { useState, useCallback, useEffect } from 'react';
import { useMediaQuery, useTheme } from '@ublend-npm/aulaui-core';
import push from '../utils/routing';

const getQueryParam = (key: string) => {
  if (typeof window === 'undefined') return null;
  const searchParams = new URLSearchParams(window.location.search);
  if (searchParams.has(key)) return searchParams.get(key);

  const hash = window.location.hash;
  if (hash.includes('?')) {
    const hashParams = new URLSearchParams(hash.substring(hash.indexOf('?')));
    return hashParams.get(key);
  }
  return null;
};

export const useResponsiveSpacesNavigation = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState<'all' | 'starred' | 'recent'>(
    'all'
  );

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    // Catch the parameter when the route changes
    const openModalParam = getQueryParam('openModal');
    if (openModalParam && !isMobile && !isModalOpen) {
      setModalType(openModalParam as 'all' | 'starred' | 'recent');
      setIsModalOpen(true);
      // Clear the query param via router so it doesn't stay in the URL
      push({ pathname: '/home', state: { tracked: true } });
    }
  }, [isMobile, isModalOpen]);

  const openSpacesList = useCallback(
    (type: 'all' | 'starred' | 'recent' = 'all') => {
      setModalType(type);
      if (isMobile) {
        push(`/all-spaces?filter=${type}`);
      } else {
        setIsModalOpen(true);
      }
    },
    [isMobile]
  );

  const closeAllSpacesModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  useEffect(() => {
    if (isMobile && isModalOpen) {
      setIsModalOpen(false);
      push(`/all-spaces?filter=${modalType}`);
    }
  }, [isMobile, isModalOpen, modalType]);

  return {
    isModalOpen,
    modalType,
    openSpacesList,
    closeAllSpacesModal,
  };
};

export default useResponsiveSpacesNavigation;
